import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '../../services/icon-registry/icon-registry.service';

@Component({
  selector: 'rd-core-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent implements OnInit {
  @HostBinding('class.rd-core-page-not-found') componentClass = true;

  constructor(private iconRegistryService: IconRegistryService) {}

  ngOnInit(): void {
    this.registerIcons();
  }

  registerIcons(): void {
    this.iconRegistryService.registerIcon('not-found');
  }
}
